import { CurrencyPipe } from '@angular/common';
import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { Company, Order } from '@authority-labs/api-interfaces';
import { Conclusion, OrderStatusEnum } from '@authority-labs/enums';
import { TableColumn } from '@check-list/app/classes';
import { UsernamePipe } from '../../pipes/username/username.pipe';

@Component({
  selector: 'authority-labs-company-status-alert',
  template: `
    <span> נא לשים לב שחברה זו ({{ company.name }}) נמצאת בסטטוס: </span>
    <br />
    <strong [authorityLabsAlertColor]="company.status?.type">{{
      company.status.name
    }}</strong>
  `,
  styles: []
})
export class AlertCompanyComponent {
  @Input() company: Company;
}

@Component({
  template: `
    <authority-labs-company-status-alert
      [company]="company"
      *ngIf="company.isStatusDanger() || company.isStatusWarning()"
    ></authority-labs-company-status-alert>
    <br />
    <div>
      <span>
        נא לשים לב שלחברה
        <i
          ><strong>{{ company.name }}</strong></i
        >
        קיימות הזמנות בסטטוס
        <i><strong>חשבונית נשלחה לתשלום - טרם נשלחה תעודה</strong></i>
        או שקיימות הזמנות המסומנות כחריגות
      </span>
    </div>
    <br />
    <authority-labs-crud-table
      title="subProjectOrders"
      parent="subProjectId"
      [simpleTable]="true"
      [hideActionsColumn]="true"
      [disableDefaultColumns]="true"
      [autoHeight]="true"
      [rows]="orders"
      [columns]="ordersColumns"
    >
    </authority-labs-crud-table>
    <ng-template #markedTpl let-entity="entity">
      <p>{{ entity.isMarked ? 'כן' : '' }}</p>
    </ng-template>
  `,
  styles: []
})
export class AlertCompanyOrdersComponent implements OnInit {
  @ViewChild('markedTpl', { static: true }) markedTpl: TemplateRef<unknown>;

  @Input() company: Company;
  @Input() orders: Order[];
  ordersColumns: TableColumn[];
  conclusions = Conclusion;
  orderStatuses = OrderStatusEnum;

  constructor(
    private currencyPipe: CurrencyPipe,
    private usernamePipe: UsernamePipe
  ) {}

  ngOnInit(): void {
    this.ordersColumns = [
      {
        prop: 'id',
        type: 'link',
        link: ['/', 'app', 'orders'],
        sortOrder: 'descend',
        width: '130px',
        isSearchVisible: false,
        hideFilter: true,
        hideSort: true
      },
      {
        prop: 'subProject',
        type: 'object',
        objectField: 'inspectionField.name',
        name: 'inspectionField.name',
        isSearchVisible: false,
        hideFilter: true,
        hideSort: true
      },
      {
        prop: 'orderCost',
        type: 'pipe',
        pipe: this.currencyPipe,
        isSearchVisible: false,
        hideFilter: true,
        hideSort: true
      },
      {
        prop: 'inspectionType',
        width: '200px',
        isSearchVisible: false,
        hideFilter: true,
        hideSort: true
      },
      {
        prop: 'assignee',
        type: 'pipe',
        pipe: this.usernamePipe,
        isSearchVisible: false,
        hideFilter: true,
        hideSort: true
      },
      {
        prop: 'status',
        type: 'object',
        objectField: 'name',
        name: 'status.name',
        width: '260px',
        isSearchVisible: false,
        hideFilter: true,
        hideSort: true
      },
      {
        prop: 'conclusion',
        width: '150px',
        isSearchVisible: false,
        hideFilter: true,
        hideSort: true
      },
      {
        prop: 'isMarked',
        type: 'template',
        cellTemplate: this.markedTpl,
        isSearchVisible: false,
        hideFilter: true,
        hideSort: true
      }
    ];
  }
}
